import { DateTime } from 'luxon';

/**
 * Formats a timezone into a readable string.
 * @param timezone - The IANA timezone string (e.g., 'America/Chicago', 'Europe/London').
 * @returns The formatted timezone string showing the abbreviation (e.g., 'CDT').
 * Example usage:
 *   getTimezoneAbbreviation('America/Chicago'); // Returns 'CDT' or 'CST' depending on DST
 */
export function getTimezoneAbbreviation(timezone: string): string {
  const currentTime = DateTime.now().setZone(timezone);
  return currentTime.offsetNameShort || ''; // Gets the timezone abbreviation (e.g., 'CST', 'CDT')
}

/**
 * Gets the timezone offset in hours and minutes from UTC.
 * @param timezone - The IANA timezone string (e.g., 'America/New_York').
 * @returns The timezone offset as a string in the format '±HH:mm' (e.g., '-05:00').
 * Example usage:
 *   getTimezoneOffset('America/New_York'); // Returns '-04:00' or '-05:00' depending on DST
 */
export function getTimezoneOffset(timezone: string): string {
  const currentTime = DateTime.now().setZone(timezone);
  return currentTime.toFormat('ZZ'); // Gets the timezone offset (e.g., '-05:00')
}
